import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import MarketplaceOfferContainerManager from 'partial/OfferManager/MarketplaceOfferContainerManager';
import MarketplaceOfferCard from 'partial/OfferManager/modules/PersonalLoanModuleRedesign/OfferCard';
import './OfferModule.scss';

const OfferSummary = props => {
  return (
    <MarketplaceOfferContainerManager
      staticModules={{ modules: props.marketPlaceCards }}
      eventHandler={props.eventHandler}
      type={props.type}
      pagePosition={'OVERVIEW_PERSONAL_LOAN_OFFERS'}
      modulePosition={props.modulePosition}
      renderContainer={props.marketPlaceCards.map((item, index) => {
        return (
          <MarketplaceOfferCard
            key={index}
            tileIconKey={item.tileIconKey}
            text={item.text}
            containerClasses="margR12 pointer"
            offerModulePosition={index + 1}
            cardName={item.cardName}
            onLinkClickEvent={() => props.onLinkClickEvent(item)}
            url={item?.url}
            verticalTracking={item.vertical}
            location={item.location}
            modulePosition={props.modulePosition}
            moduleName={props.offerInfo}
          />
        );
      })}
    />
  );
};

const PersonalLoanHighScoreModuleView = props => {
  const { marketPlaceCards, onLinkClickEvent, eventHandler, type } = props;
  return (
    <>
      <FlexContainer className="flex-column personalLoanOfferContainer">
        <OfferSummary
          marketPlaceCards={marketPlaceCards}
          eventHandler={eventHandler}
          onLinkClickEvent={onLinkClickEvent}
          type={type}
          {...props}
        />
      </FlexContainer>
    </>
  );
};

export default PersonalLoanHighScoreModuleView;
